const REDACTED_KEYS = new Set([
  "authorization",
  "access_token",
  "id_token",
  "refresh_token",
  "client_secret",
  "code_verifier",
]);

const MAX_DEPTH = 5;

const maskString = (value) => {
  const text = String(value ?? "");
  if (!text) return text;

  return text
    .replace(/Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi, "Bearer [REDACTED]")
    .replace(/"?(access_token|id_token|refresh_token|client_secret|authorization|code_verifier|code|state)"?\s*:\s*"[^"]*"/gi, '"$1":"[REDACTED]"');
};

export { maskString };

const sanitizeValue = (value, depth = 0, seen = new WeakSet()) => {
  if (value == null) return value;
  if (typeof value === "string") return maskString(value);
  if (typeof value !== "object") return value;
  if (depth >= MAX_DEPTH) return "[Truncated]";
  if (seen.has(value)) return "[Circular]";

  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((item) => sanitizeValue(item, depth + 1, seen));
  }

  const output = {};
  Object.entries(value).forEach(([key, entryValue]) => {
    if (REDACTED_KEYS.has(String(key).toLowerCase())) {
      output[key] = "[REDACTED]";
      return;
    }
    output[key] = sanitizeValue(entryValue, depth + 1, seen);
  });

  return output;
};

export const sanitizeForLog = (value) => sanitizeValue(value);

export const serializeErrorForLog = (error) => {
  if (!error) return error;

  const summary = {
    name: error.name,
    message: maskString(error.message || "Error desconocido"),
    code: error.code,
  };

  if (error.response) {
    summary.response = sanitizeForLog({
      status: error.response.status,
      statusText: error.response.statusText,
      data: error.response.data,
    });
  }

  if (error.config) {
    summary.request = sanitizeForLog({
      method: error.config.method,
      baseURL: error.config.baseURL,
      url: error.config.url,
      headers: error.config.headers,
    });
  }

  return summary;
};

export const logSafeError = (level, message, error, extra = undefined) => {
  const logger = console[level] || console.error;
  const payload = {
    ...(extra ? sanitizeForLog(extra) : {}),
    error: serializeErrorForLog(error),
  };
  logger(message, payload);
};
